import { MasterTransaction } from '@model/MasterTransaction'

import { BonusTransactionDto } from './BonusTransactionDto'
import { NameDto } from './NameDto'
import { TransactionLinksDto } from './TransactionLinksDto'
import { TwoFactor } from './User'
import { CurrencyType, WalletDto } from './WalletDto'

export interface MasterTransactionDto {
  id: string
  referenceId: string | null
  type: NameDto
  state: NameDto
  comment: string | null
  date: string
  settlementDate: string
  createdDate: string
  updatedDate: string
  reverseTransaction: NameDto
  reversedTransactions: NameDto[]
  walletTransactions: WalletTransactionDto[]
  groupReference?: TransactionGroupReferenceDto
  tradingAccountTransactions: TradingAccountTransactionDto[]
  linkedFrom: TransactionLinksDto[]
  linkedTo: TransactionLinksDto[]
  twoFactor?: TwoFactor[]
}

interface GroupReferenceTransaction {
  id: string
  name: string
  referenceId: string
  type: NameDto
  state: NameDto
  debitAmount: number
  creditAmount: number
}

interface TransactionGroupReferenceDto {
  id: string
  name: number
  type: NameDto
  totalWalletsAmount: number
  totalPaymentsAmount: number
  walletCurrencyId: string
  paymentsCurrencyId: string
  transactions: GroupReferenceTransaction[]
  dateCreated: string
  dateUpdated: string
}

interface TradingAccountTransactionDto {
  id: string
  directionType: NameDto
  amount: number
  tradingAccount: NameDto
  wallet: NameDto
  client: NameDto
  tickmillCompany: NameDto
  currency: NameDto
}

export interface WalletTransactionDto {
  id: string
  directionType: NameDto
  amount: number
  currencyRate: number
  otherAmount: number
  otherCurrency: {
    id: CurrencyType
    name: string
  }
  wallet: WalletDto
  paymentProviderTransaction: PaymentProviderTransactionDto
  paymentAgentTransaction: PaymentAgentTransactionDto
  ibCommisionTransaction: IbCommisionTransactionDto
  bonusTransaction: BonusTransactionDto
}

export interface PaymentProviderTransactionDto {
  id: string
  providerReference: string | null
  paymentProvider: NameDto
  currency: NameDto
  request: PaymentProviderTransactionRequestDto
  response: PaymentProviderTransactionResponseDto
  isConnectedToService: boolean
}

interface PaymentProviderTransactionRequestDto {
  [key: string]: string
}

export type PaymentProviderRedirectData =
  | {
      [key: string]: string | undefined
    }
  | PaymentProviderRedirectKeyValue[]
  | null

export interface PaymentProviderRedirectKeyValue {
  name?: string | null
  value?: string | number | null
}

export interface PaymentProviderQrDto {
  type: string
  method: string
  prepared: string | null
  url: string | null
  data: PaymentProviderRedirectData
  dataKeyValue?: PaymentProviderRedirectKeyValue[] | null
}

export interface PaymentProviderTransactionResponseDto {
  redirect: {
    type: string
    method: null
    url: null
    data: PaymentProviderRedirectData
    prepared: null
    dataKeyValue?: PaymentProviderRedirectKeyValue[] | null
  }
  qr?: PaymentProviderQrDto | null
}

interface PaymentAgentTransactionDto {
  id: string
  documentId: string | null
  paymentAgent: NameDto
  system: string | null
  account: string | null
}

interface IbCommisionTransactionDto {
  id: string
  introducingBroker: NameDto
  lotCount: number
}

const STATIC_REDIRECT_TYPES = ['static', 'key_value']

export const isTransactionRedirectStaticType = (data?: MasterTransaction): boolean => {
  const [walletTransaction] = data?.walletTransactions || []
  const redirectType = walletTransaction?.paymentProviderTransaction?.response?.redirect?.type

  if (!redirectType) {
    return false
  }

  return STATIC_REDIRECT_TYPES.includes(redirectType)
}
